module.exports = __webpack_public_path__ + "img/logo-humanway.d3dba6c1.png";